// import DoTime from './Time/DoTime'
class DoDecrypt {
  constructor() {
    this.a = 'bHZ5YWx2eWE4ODg4bHZ5YQ=='
    this.b = 'YWJjZHl5eXlNTWRkZWZnaA=='
    this.c = 'aGlqa2x2eWFfbW5vcHE='
  }
  // 解密，加密方法：btoa(encodeURIComponent('lvya' + password))
  // atob() {
  //   // let _password = decodeURIComponent(atob(this.a))
  //   // return _password.slice(4, 12)
  //   let _qz = decodeURIComponent(atob(this.c))
  //   let _dt = decodeURIComponent(atob(this.b))
  //   let _time = _qz.slice(4, 9) + DoTime.dateFormat(_dt.slice(4, 12))
  //   return _time
  // }
  atob() {
    return ''
  }
}
export default new DoDecrypt()

/*
引入：import DoDecrypt from '@lvya-common/src/utils/DoDecrypt'
调用：DoDecrypt.atob()
*/
